import React from 'react';
import { useTranslation } from 'react-i18next';
import { WeezHeader, Button, Icon } from '@weezevent/nacre';
import WidgetList from '../../widgetList';
import WidgetCreationModal from '../../components/widget_creation_modal/modal';

export default function PersonalSpacesList({ organization }) {
    const { t } = useTranslation();
    const [openCreationModal, setOpenCreationModal] = React.useState(false);

    return (
        <>
            {openCreationModal && (
                <WidgetCreationModal open={openCreationModal} organization={organization} onClose={() => setOpenCreationModal(false)} allowedTemplates={['ManageTemplate']} />
            )}
            <WeezHeader
                title={t('ticket.personal_spaces.list.title')}
                rightComponent={[
                    <Button key={0} onClick={() => setOpenCreationModal(true)} primary icon={<Icon name="plus" />}>
                        {t('ticket.personal_spaces.list.create_new')}
                    </Button>
                ]}
            >
                {t('ticket.personal_spaces.list.description')}
            </WeezHeader>
            <WidgetList onlyWidgetEngine usages={['personal_space', 'moderation']} context="personal_space" organizationId={organization.id} />
        </>
    );
}
